/**
 * AI.GEN lines=1-25
 * 主题颜色常量 - 统一管理项目中使用的颜色变量
 * 用于 app.tsx 主题配置和其他 TypeScript 文件
 * Less 变量定义在 global.less 中，保持一致
 */

export const THEME_COLORS = {
  /** 主色黄色 */
  primary: '#ffdb00',
  /** 主色hover亮黄色 */
  primaryHover: '#ffe866',
  /** focus/hover边框黑色 */
  focusBorder: '#000000',
  /** 主文字颜色 */
  textPrimary: 'rgba(0, 0, 0, 0.88)',
  /** 禁用文字颜色 */
  textDisabled: 'rgba(0, 0, 0, 0.25)',
  /** 白色 */
  white: '#ffffff',
  /** 默认边框颜色 */
  border: '#d9d9d9',
  /** 浅色背景 */
  bgLight: '#f5f5f5',
  /** 更浅色背景 */
  bgLighter: '#fafafa',
  /** 日期范围选中背景 */
  rangeBg: '#fff9e2',
} as const;

/** 主题颜色类型 */
export type ThemeColors = typeof THEME_COLORS;
